module.exports = __webpack_public_path__ + "src/assets/img/m32.17bf850d.svg";